//
//  CsvDownloadList.tsx
//
//  isana.net,inc. Proprietary and Confidential
//

import { ReactElement } from "react";
import { Container, CircularProgress, Box } from "@mui/material";
import CsvDownloadTable from "./component/CsvDownloadTable";
import useCsvDownloadList from "./hooks/useCsvDownloadList";

const CsvDownloadList = (): ReactElement => {
  const {
    displayedFiles,
    count,
    showProgress,
    rowsPerPage,
    page,
    handlePageChange,
  } = useCsvDownloadList();

  return (
    <>
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Container
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 3,
          }}
        ></Container>
        {showProgress ? (
          <CircularProgress sx={{ m: 5 }} />
        ) : (
          <CsvDownloadTable
            files={displayedFiles}
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            hadlePageChange={handlePageChange}
          />
        )}
      </Container>
    </>
  );
};

export default CsvDownloadList;
